export const SET_CONFIG = 'SET_CONFIG';
export const SUCCESS_RESEND = 'SUCCESS_RESEND';
